export const invite = {
    "fuwutiaokuan": "《서비스 약관》",
    "yinsizhengce": "《개인정보 처리방침》",
    "fzcg": "복사 성공",
    "yqhy": "친구 초대",
    "fxlj": "링크 공유",
    "register_now": "지금 등록하기",
    "phone": "핸드폰",
    "email": "이메일",
    "placehold_phone": "핸드폰 번호를 입력하세요",
    "placehold_email": "이메일 주소를 입력하세요",
    "placehold_code": "초대 코드",
    "argee": "내가 읽고 동의했습니다",
    "agreement": "《BiKing 사용자 계약》",
    "register": "등록",
    "phone_code": "문자 메시지 인증 코드",
    "email_code": "이메일 인증 코드",
    "code_to_phone": "인증 코드가 문자 메시지로 핸드폰으로 전송되었습니다",
    "code_to_email": "인증 코드가 이메일로 전송되었습니다",
    "has_sent": "인증 코드가 이미 전송되었습니다:",
    "resend": "다시 보내기",
    "send_code": "인증 코드 전송",
    "unable_code": "인증 코드를 받을 수 없습니까?",
    "set_pwd": "비밀번호 설정",
    "placehold_pwd": "비밀번호를 입력하세요",
    "submit": "제출",
    "error_phone": "올바른 핸드폰 번호를 입력하세요",
    "error_email": "올바른 이메일 형식이 아닙니다. 다시 입력하세요.",
    "error_checked": "계약서를 확인한 후 다시 시도하세요",
    "text": "비밀번호 형식이 잘못되었습니다. 비밀번호는 8-32자여야 하며 대문자, 소문자 및 숫자를 포함해야 합니다.",
    "validate": "인증을 완료하세요",
    "register_success": "등록 성공!",
    "welcome": "BiKing에 오신 것을 환영합니다",
    "start_trade": "암호화폐를 충전하여 거래를 시작하세요",
    "safe": "다양한 충전 방법으로 안전하고 편리하게 암호화폐를 거래하세요",
    "pay_type": "은행 계좌 또는 다른 결제 수단을 통해 암호화폐를 사고 팔 수 있습니다",
    "right_now_download": "지금 다운로드하기",
    "right_download": "다운로드",
    "Please_enter_correct_phone_number": "올바른 핸드폰 번호를 입력하세요",
    "Referral_code": "초대 코드를 입력하세요",
    "I_have_read_and_agree": "내가 읽고 동의합니다",
    "BiKing_User_Agreement": "《BiKing 사용자 계약》",
    "Please_enter_password": "비밀번호를 입력하세요",
    "Email_verification_code": "이메일 인증 코드",
    "SMS_code": "문자 메시지 인증 코드",
    "Incorrect_email_format_please_reenter": "올바른 이메일 형식이 아닙니다. 다시 입력하세요",
    "Please_read_and_agree_User_Agreement": "계약서를 읽고 동의한 후 진행하세요",
    "Sent_code_to": "인증 코드가 다음으로 전송되었습니다",
    "zjff": "즉시 지급!",
    "ycxdz": "일시적으로 계정으로 입금!",
    "bbsy": "0 비용 백 배 이익!",
    "sdly": "비킹 거래 선택의 세 가지 이유",
    "aqfktx": "세계 최고 수준의 안전 위험 관리 시스템",
    "aqhg": "안전하고 법적으로 신뢰할 수 있는 가치 네트워크, 전문 분산 아키텍처 및 DDOS 공격 방지 시스템",
    "qqbthyytd": "글로벌 로컬 운영 팀",
    "qqbj": "글로벌 네트워크 배치, 여러 국가에서 로컬 서비스 제공, 다양한 비즈니스 형태의 블록체인 생태계 구축",
    "fwtx": "사용자 중심 서비스 체계 재구축",
    "yhzs": "사용자 중심, 창의적인 선도 보상 메커니즘, 사용자 보호 기금 설립",
    "jslc": "해제 프로세스",
    "zcwcjkjs": "등록이 완료되면 1188USDT가 선물 잔액으로 지급되어 해제됩니다.",
    "czts": "조작 예 : 등록 후 선물로 받은 1000USDT로 20 배 레버리지 BTC 롱 포지션을 구매하면 BTC가 1% 상승하면 수익은 20%인 200USDT가됩니다. 이 수익은 직접 인출 할 수 있습니다.",
    "zhu": "참고 :",
    "qzlqyky": "1188USDT는 단일 거래로 여러 번에 걸쳐 지급되며 모든 계약에서 사용할 수 있습니다.",
    "gqql": "1188USDT 사용 기간은 1 개월이며, 만료 시 잔액이 초기화됩니다."
    
  }


// WEBPACK FOOTER //
// ./src/i18n/lang/invite/kr.js